import { Box, Container, Typography, styled } from "@mui/material"
import type { ReactNode } from "react"
import { StickyHeaderSlot } from "./StickyHeaderSlot"

const BAR_HEIGHT = "48px"

/**
 * Page title + content (usually a `SectionNav`), displayed in the sticky
 * header once the page is scrolled.
 *
 * Renders nothing inline: the page stays responsible for what it displays
 * at the top of the page, so a nav can be rendered on both sides without
 * duplicating its state.
 */
export const StickyPageBar = ({
  title,
  children,
  order = 0,
}: {
  title: string
  order?: number
  children: ReactNode
}) => (
  <StickyHeaderSlot order={order}>
    <Bar>
      <Container maxWidth="lg">
        <Row>
          <Typography variant="18px" fontWeight={600}>
            {title}
          </Typography>
          {children}
        </Row>
      </Container>
    </Bar>
  </StickyHeaderSlot>
)

const Bar = styled(Box)(({ theme }) => ({
  width: "100%",
  backgroundColor: theme.palette.common.white,
  borderBottom: "1px solid #eee",
}))

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(5),
  height: BAR_HEIGHT,
}))
